var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientbluestatsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23V20.309C0 15.5542 4.52268 12.2334 10.9995 12.2334C17.4773 12.2334 22 15.5542 22 20.309V23H0ZM2.75078 20.309H8.43095L5.57756 16.1204C3.80474 17.0757 2.75078 18.5424 2.75078 20.309ZM10.9995 14.9252C10.017 14.9252 9.09668 15.0199 8.24964 15.1933L10.9995 19.2289L13.7504 15.1933C12.9033 15.0199 11.983 14.9252 10.9995 14.9252ZM16.4215 16.1204L14.1533 20.309H19.2501C19.2501 18.5424 18.1943 17.0757 16.4215 16.1204ZM10.9995 10.7667C7.96851 10.7667 5.50066 8.35166 5.50066 6.05166C5.50066 2.415 7.96851 0 10.9995 0C14.0324 0 16.5002 2.415 16.5002 6.05166C16.5002 8.35166 14.0324 10.7667 10.9995 10.7667ZM10.9995 3.03512C9.48402 3.03512 8.25054 3.89939 8.25054 6.05166C8.25054 6.86816 9.48402 8.07477 10.9995 8.07477C12.5178 8.07477 13.7504 6.86816 13.7504 6.05166C13.7504 3.89939 12.5178 3.03512 10.9995 3.03512Z",
    fill: "#3DA3B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientbluestatsicon);
export default __webpack_public_path__ + "static/media/patientbluestatsicon.6aadaa858095632e8eb6b95c64c170ac.svg";
export { ForwardRef as ReactComponent };